import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import moment from 'moment'
import ConsultaConIngreso from './ConsultaConIngreso'
import ConsultaSinIngreso from './ConsultaSinIngreso'

class Consulta extends Component {
  constructor (props) {
    super(props)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.getDetalleMercaderia = this.getDetalleMercaderia.bind(this)
    this.descargarDetallesPDF = this.descargarDetallesPDF.bind(this)
  }

  componentDidMount () {
    const { cpaConsultaCupo } = this.props
    if (cpaConsultaCupo) {
      var cpa
      if (cpaConsultaCupo.filas_procesadas > 0) {
        cpa = cpaConsultaCupo.filas[0]
      } else {
        cpa = cpaConsultaCupo
      }
      console.log(cpa)
    }
  }

  handleOpen () {
    this.props.updateShowInfoVolcadoras(true)
  }

  handleClose () {
    this.props.updateShowInfoVolcadoras(false)
  }

  getDetalleMercaderia (numero) {
    this.props.getDetalleMercaderia(numero)
  }

  descargarDetallesPDF () {
    this.props.descargarDetalles()
  }

  render () {
    const {
      cpaConsultaCupo,
      handleReset,
      getTurnosPendientes,
      getTotalCamiones,
      getCamionesPedidos,
      getCortes
    } = this.props

    var cpa
    if (cpaConsultaCupo.filas_procesadas > 0) {
      cpa = cpaConsultaCupo.filas[0]
    } else {
      cpa = cpaConsultaCupo
    }

    var fechaCupo = Date.parse(cpa.fechaCupo)

    if (isNaN(fechaCupo)) {
      fechaCupo = moment.unix(cpa.fechaCupo).format('DD/MM/YYYY')
    } else {
      fechaCupo = moment(cpa.fechaCupo, 'YYYY/MM/DD').format('DD/MM/YYYY')
    }

    return (
      <div>
        {/* Si el camion aun no tiene ingreso */}
        {cpa && !cpa.fechaDeIngreso && <ConsultaSinIngreso cpa={cpa} fechaCupo={fechaCupo} getTotalCamiones={getTotalCamiones} handleReset={handleReset} />}

        {/* Si el camion ya tiene ingreso  */}
        {cpa && cpa.fechaDeIngreso && <ConsultaConIngreso cpa={cpa} obtenerDetalleMercaderia={this.getDetalleMercaderia} descargarDetallesPDF={this.descargarDetallesPDF} getTurnosPendientes={getTurnosPendientes} getTotalCamiones={getTotalCamiones} getCamionesPedidos={getCamionesPedidos} getCortes={getCortes} fechaCupo={fechaCupo} handleReset={handleReset} /> }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  cerealVolcadoras: state.volcadora.cerealVolcadoras,
  turnosPendientes: state.camionesIngreso.turnosPendientesPlaya
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(Consulta)
